import React from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { Box } from "@mui/material";
import { Controller } from "react-hook-form";
import { useSelector } from "react-redux";


// 새로운 API 엔드포인트
const API_URL = "https://api.bodyswitch.co.kr"; // admin 서버 URL
// const API_URL = "http://localhost:8081"; // admin 서버 URL
const UPLOAD_ENDPOINT = "admin/api/v1/images/upload"; // 새로 만든 업로드 엔드포인트

export default function FormInputCEditor({
  name,
  sx,
  control,
  setValue,
  data,
  setLoading = () => {},
  directory = "editor", // CKEditor용 디렉터리 기본값
}) {
  // Redux store에서 user token 가져오기
  const user = useSelector(state => state.user.user);
  const token = user?.token;

  function uploadAdapter(loader) {
    setLoading(true);
    return {
      upload: () => {
        return new Promise((resolve, reject) => {
          const formData = new FormData();

          loader.file.then(async (file) => {
            // 새로운 API에 맞게 FormData 구성
            formData.append("file", file);


            try {
              const response = await fetch(`${API_URL}/${UPLOAD_ENDPOINT}?directory=${directory}`, {
                method: "POST",
                body: formData,
                headers: {
                  // Authorization 헤더 추가
                  'Authorization': `Bearer ${token}`
                },
              });

              if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
              }

              const result = await response.json();

              // 새로운 API 응답 구조에 맞게 수정
              if (result.success && result.imageUrl) {
                resolve({
                  default: result.imageUrl, // S3에 업로드된 이미지 URL
                });
              } else {
                throw new Error(result.message || "업로드 실패");
              }

            } catch (error) {
              console.error("Image upload error:", error);
              reject(error);
            } finally {
              setLoading(false);
            }
          });
        });
      },
    };
  }

  function uploadPlugin(editor) {
    editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
      return uploadAdapter(loader);
    };
  }

  return (
    <Controller
      name={name}
      control={control}
      render={() => (
        <Box sx={{ overflow: "auto", ...sx }}>
          <CKEditor
            editor={ClassicEditor}
            watchdogConfig={true}
            config={{
              removePlugins: ["MediaEmbed"],
              extraPlugins: [uploadPlugin],
              // 추가 설정 옵션
              toolbar: {
                items: [
                  'heading',
                  '|',
                  'bold',
                  'italic',
                  'link',
                  'bulletedList',
                  'numberedList',
                  '|',
                  'outdent',
                  'indent',
                  '|',
                  'imageUpload',
                  'blockQuote',
                  'insertTable',
                  'mediaEmbed',
                  'undo',
                  'redo'
                ]
              },
              image: {
                toolbar: [
                  'imageStyle:inline',
                  'imageStyle:block',
                  'imageStyle:side',
                  '|',
                  'toggleImageCaption',
                  'imageTextAlternative'
                ]
              }
            }}
            data={data ? data : ""}
            onChange={(event, editor) => {
              const data = editor.getData();
              setValue(name, data);
            }}
            onError={(error, { willEditorRestart }) => {
              console.error("CKEditor error:", error);
              if (willEditorRestart) {
                console.log("Editor will restart");
              }
            }}
          />
        </Box>
      )}
    />
  );
}